import {getId} from 'apis/model/base'
import React, {useContext} from 'react'
import {NullAsDefault, renderSelf} from 'views/Shared'
import EntityList from '../../EntityList'
import {bindQueryParams} from '../../functions/routerHelper'
import {timetable_getMilestonesByDepartment_Api} from 'apis'
import {BsInboxesFill} from 'react-icons/bs'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import useTranslate from 'modules/local/useTranslate'
import {ActionModalWrapper} from 'components/form/ActionModalWrapper'
import {useTimetableOrganizationForm} from 'views/AppLocals/Timetable/useTimetableOrganizationForm'
import {renderTimetableItem} from 'views/AppLocals/Timetable/TimetableForm'

export const OrganizationTimetables = ({
                                           item: organizationGroup,
                                           header = null,
                                           renderFooter = renderSelf,
                                       }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {
        modal,
        renderContextMenu,
        handleAction = NullAsDefault,
        refreshKey
    } = useTimetableOrganizationForm({
        organizationGroup: organizationGroup,
        organization: organizationGroup?.organization,
    })
    const {organization} = organizationGroup ?? {}

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="mt-6 flex flex-col gap-1">
                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                    {t('detail timetable')}
                </div>
                <div className="mt-3 flex flex-col gap-4">
                    {!!organizationGroup?.id && (
                        <EntityList
                            refreshKey={refreshKey}
                            RenderEntity={React.Fragment}
                            query={bindQueryParams([{id: getId(organizationGroup)}])}
                            apiInfo={timetable_getMilestonesByDepartment_Api}
                            renderItem={renderTimetableItem({renderContextMenu})}
                            renderWrap={(child) => (
                                <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                                    {child}
                                </div>
                            )}
                            renderEmpty={() => (
                                <div
                                    className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                    <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                                    <span className="text-center text-sm text-color-300 tracking-wider italic">
                                            {t('no data is available now')}
                                        </span>
                                </div>
                            )}
                        />
                    )}
                </div>
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}
